import { ReactElement } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import LoginUserForm from '@/components/molecules/LoginUserForm'
import { WithEmployerHeaderLayout } from '@/components/layouts'
import { targetPath, targetQuery } from '@/helpers/url'
import CustomHead from '@/components/molecules/CustomHead'

interface IProps {
  header: boolean
}
export default function SignInEmployer({ header = true }: IProps) {
  const { t } = useTranslation('common')
  const { data: session } = useSession()
  const router = useRouter()
  const { target } = router.query
  const metaData = {
    title: t('common:login_to_bulldog'),
    noindex: true,
  }
  if (session && session?.authToken?.includes('user')) {
    setTimeout(() => {
      router.push({
        pathname: targetPath(target as string, '/dashboard'),
        query: targetQuery(target as string, {}),
      })
    }, 200)
    return <></>
  }

  return (
    <>
      <CustomHead metaData={metaData} />
      <section className='bg-gray-bg h-screen'>
        <div className='container relative'>
          <div className='container-small'>
            <div className='pt-24'>
              {header && (
                <header className='mb-6'>
                  <h1 className='text-4xl font-medium '>
                    {t('common:user_signin_header')}
                  </h1>
                </header>
              )}
              <LoginUserForm />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

SignInEmployer.getLayout = function getLayout(page: ReactElement) {
  return (
    <WithEmployerHeaderLayout withFooter={false}>
      {page}
    </WithEmployerHeaderLayout>
  )
}
